import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import Transition from '@/components/Common/Transition';

type Props = {
  children: ReactNode;
  style?: CSSProperties;
  status: boolean;
};

const GuideTooltip = (props: Props) => {
  return (
    <Transition status={props.status}>
      <Style style={props.style}>{props.children}</Style>
    </Transition>
  );
};

const Style = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.colors.gray100};
  color: ${(props) => props.theme.colors.gray700};
  padding: 8px;
  border-radius: 6px;
  backdrop-filter: blur(12px);
  box-shadow: 0px 2px 8px ${(props) => props.theme.colors.FD16};
`;

export default GuideTooltip;
